<template>
    <div>
        
        <hbtTyp/>
        <hbtRodape/>
    </div>
</template>

<script>
// import HbtNavbar from './Navbar';
import HbtTyp from '../components/Typ';
import HbtRodape from '../components/Rodape';

export default {

    components: {
        // HbtNavbar,
        HbtTyp,
        HbtRodape,
    },
    data: () => ({
        //
    }),
    
}
</script>